// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f92185dd","703":"d5f9bfb2"}[chunkId] + ".chunk.js";
};